export const title = 'Welcome to Groov';

export const description =
  'Groov has the tools you need to take small daily steps towards feeling good and functioning better.';

// Toast strings
export const errorTitle = 'Error';
export const errorMessage = 'Error getting user details';
export const tryAgainLink = 'Try again';
export const dimissLink = 'Dismiss';
export const progressMessage = 'Retrieving user details';

// User error
export const userErrorTitle = 'Something’s gone wrong!';
export const userErrorDescription = `You must be a Groov customer to use the Groov Teams app. Your organisation is either not an existing Groov Customer, or your organisation has not yet been registered to use the Groov Teams app.`;
export const accessOutsideOfTeams = 'If you are accessing this page from outside of Teams, please ';
export const accessOutsideOfTeamsLink = 'access the app from within Teams.';
export const contactSupport = 'If you are an existing Groov Customer, please ';
export const contactSupportLink = 'contact support ';
export const registerMessage =
  'to register for the Groov Teams app. Alternatively, if you are interested in becoming a Groov customer please ';
export const getInTouchLink = 'get in touch ';
export const registerMessagePart2 = 'via our website or call us on ';
export const ukContact = ' +44 7539 874207 (UK)';
export const auContact = ' +61 2 8310 6320 (AUS)';
export const nzContact = ' +64 9 801 8029 (NZ)';
